import { gql } from "@apollo/client";

export default gql`
  mutation askAiArchiveSkill($id: UUID!) {
    archiveSkill(id: $id) {
      skill {
        id
        archivedAt
      }
    }
  }
`;
